<template>
  <svg class="icon" aria-hidden="true" :style="iconStyle">
    <use :xlink:href="`#icon-${name}`" />
  </svg>
</template>

<script lang="ts">
import { computed } from 'vue';

export default {
  name: 'IconSymbol',
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: [String, Number],
      default: '1em',
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
  setup(props) {
    // 计算图标样式
    const iconStyle = computed(() => ({
      width: typeof props.size === 'number' ? `${props.size}px` : props.size,
      height: typeof props.size === 'number' ? `${props.size}px` : props.size,
      fill: props.color,
    }));

    return {
      iconStyle,
    };
  },
};
</script>

<style scoped>
.icon {
  display: inline-block;
  vertical-align: -0.15em;
  overflow: hidden;
}
</style>
